import { createStandardAction } from 'typesafe-actions';

const APP_START_LISTENING_BROWSER_ONLINE_STATE = 'APP_START_LISTENING_BROWSER_ONLINE_STATE';
const APP_CHECK_ONLINE_STATE = 'APP_CHECK_ONLINE_STATE';

const APP_GO_ONLINE = 'APP_GO_ONLINE';
const APP_GO_OFFLINE = 'APP_GO_OFFLINE';

export const startListeningBrowserOnlineState = createStandardAction(APP_START_LISTENING_BROWSER_ONLINE_STATE)();
export const checkAppOnlineState = createStandardAction(APP_CHECK_ONLINE_STATE)();

export const appGoOnline = createStandardAction(APP_GO_ONLINE)();
export const appGoOffline = createStandardAction(APP_GO_OFFLINE)();

export const appStateRestored = createStandardAction('@app/state_restored')();



// WEBPACK FOOTER //
// ./src/containers/App/actions.ts